import $ from 'jquery';
import {POPIN_PROFILE_DEFAULT_VALUES} from "../commons/loginbox/popin/popinNavProPri";
var SELECTOR_POPIN = 'js--popinNavpropri',
    SELECTOR_POPIN_MODAL = 'js--popinNavpropri-modal',
    SELECTOR_POPIN_CLOSE = 'js--popinNavpropriClose';
const initNavpropri = function (market) {
    var navproplinks = document.getElementsByClassName("js-navpropri");
    for(var navproplink of navproplinks){
        if (window.cmsGlobals.navpropri.hidden === false) {

            navproplink.onclick = function(e) {
                //e.preventDefault();
                if(market === 1){
                    window.bddfTms.trackEvent(this, 'click_menu', {event_name : 'navigation-connectee::acces-espace-professionnels'});
                }else {
                    window.bddfTms.trackEvent(this, 'click_menu', {event_name: 'navigation-connectee::acces-espace-particulier'});
                }

                if(checkSupervision()){
                    if (document.getElementsByClassName(SELECTOR_POPIN)[0] !== undefined) {
                        var $popinNavpropri = document.getElementsByClassName(SELECTOR_POPIN)[0];
                        var $popinNavpropriModal = document.getElementsByClassName(SELECTOR_POPIN_MODAL)[0];
                        document.getElementsByClassName(SELECTOR_POPIN_CLOSE)[0].onclick = function(e){
                            hideContainers($popinNavpropri, $popinNavpropriModal);
                        };

                        //$popinNavpropri.appendTo(document.body);

                        bindEvent(navproplink, $popinNavpropri, $popinNavpropriModal);
                        return false
                    }else{
                        return false;
                    }
                }
                if (window.cmsGlobals.navpropri.disabled) {
                    if(window.cmsGlobals.navpropri.urlDisable !== ""){
                        window.location.href = window.cmsGlobals.navpropri.urlDisable;
                        window.EventBusCMS.dispatchEvent('buildSearch', {isReady: 'navpropri'});
                        return false;
                    }else{
                        return false;
                    }
                }

                var settings = {
                    "async": false,
                    "url": window.cmsGlobals.navpropri.urlServiceSas,
                    "method": "GET",
                    "dataType": 'json'
                };


                $.ajax(settings)
                    .done(function (response) {
                        if (typeof response !== undefined) {
                            var statusnav;

                            if (response.commun.statut === "ok"){
                                statusnav = getStatus(response, market);
                            }

                            if (response.commun.statut === 'ok' && statusnav === 'nok') {
                                window.location.href = window.cmsGlobals.navpropri.urlSasKO;
                            }
                            else if (response.commun.statut === 'ok' && statusnav === 'consent_await') {
                                // Dans le cas ou PRI est notre point d'origine
                                if(market === 1 && (sasJs === undefined || sasJs["user-auth-origin"] === undefined || sasJs["user-auth-origin"] !== "PRO")){
                                    window.location.href = window.cmsGlobals.navpropri.urlNonEligible;
                                }else {
                                    window.location.href = window.cmsGlobals.navpropri.urlConsentAwait;
                                }
                            }
                            else if (response.commun.statut === 'ok' && statusnav === 'consent_refused') {
                                // Dans le cas ou PRI est notre point d'origine
                                if(market === 1 && (sasJs === undefined || sasJs["user-auth-origin"] === undefined || sasJs["user-auth-origin"] !== "PRO")){
                                    window.location.href = window.cmsGlobals.navpropri.urlNonEligible;
                                }else {
                                    window.location.href = window.cmsGlobals.navpropri.urlConsentementKO;
                                }
                            }
                            else if (response.commun.statut === 'ok' && statusnav === 'non_eligible') {
                                window.location.href = window.cmsGlobals.navpropri.urlNonEligible;
                            }
                            else if (response.commun.statut === 'ok' && statusnav === 'ok') {
                                //on supprime le flag de la popin navpropri de la session avant de la fermer
                                window.sessionStorage.removeItem(POPIN_PROFILE_DEFAULT_VALUES.SESSION_STORAGE_POPIN_ACTIVATED);
                                closeSessionAndSetUrl(response, market);
                            } else {
                                if(response.commun.raison !== "niv_auth_insuff"){
                                    window.location.href = window.cmsGlobals.navpropri.urlSasKO;
                                }else{
                                    window.location.reload();
                                }
                            }
                        } else {
                            window.location.href = window.cmsGlobals.navpropri.urlSasKO;
                        }
                        window.EventBusCMS.dispatchEvent('buildSearch', {isReady: 'navpropri'});

                    })
                    .fail(function () {
                        window.location.href = window.cmsGlobals.navpropri.urlSasKO;
                        window.EventBusCMS.dispatchEvent('buildSearch', {isReady: 'navpropri'});
                    });
            };
        }
    }

    function closeSessionAndSetUrl(responseSAS, market){
        var settingsDeco = {
            "async": false,
            "url": window.cmsGlobals.navpropri.urlCloseSession,
            "method": "GET",
            "dataType": 'json'
        }
        $.ajax(settingsDeco).done(function (){
            var tokennav = getToken(responseSAS, market);

            var nameToken;
            if(market === 1){
                nameToken = "ktoken_navpripro";
            }else{
                nameToken = "ktoken_navpropri";
            }

            var hiddenForm = $('<form action="'+window.cmsGlobals.navpropri.urlConsentementOK+'" method="POST" style="display:none;"></form>')
                .appendTo(document.body);

            $('<input type="hidden" />').attr({
                name: nameToken,
                value: tokennav,
            }).appendTo(hiddenForm);

            hiddenForm.submit();
            hiddenForm.remove();
        }).fail(function(){});
    }


    function getToken(response, market){
        if(market === 1){
            return response.donnees.navpripro.token;
        }else{
            return response.donnees.navpropri.token;
        }
    }
    function getStatus(response, market){
        if(market === 1){
            return response.donnees.navpripro.status;
        }else{
            return response.donnees.navpropri.status;
        }
    }

    function checkSupervision(){
        if(sasJs !== undefined && sasJs["user-info-sup"] !== undefined && sasJs["user-info-sup"] === "true"){
            return true;
        }else{
            return false;
        }
    }

    function displayContainers($popinLogin, $popinNavpropriModal){
        $popinLogin.style.display = 'block';
        $popinNavpropriModal.style.display = 'block';
    }

    function hideContainers($popinLogin, $popinNavpropriModal){
        $popinLogin.style.display = 'none';
        $popinNavpropriModal.style.display = 'none';
    }

    function bindEvent($popinBtn, $popinLogin, $popinNavpropriModal){
        if($popinLogin.style.display === 'none') {
            displayContainers($popinLogin, $popinNavpropriModal);
        } else  {
            hideContainers($popinLogin, $popinNavpropriModal);
        }
    }
};

export {initNavpropri};


// WEBPACK FOOTER //
// ./src/js/cms/util/navpropri.js